import React, { useState, useRef } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { LogInSchoolID } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { useNavigate } from 'react-router-dom';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { useSelector } from 'react-redux';
import { ApiCmnHeadersPostCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import useConfig from '../../../Hooks/useConfig';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';

export default function ImportDevices() {
    const { inventory_with_student, csvFilesPrefix, withoutUserFileType, withUserFileType } = useConfig();
    const StateData = useSelector((state) => state.authData);
    const navigate = useNavigate();
    const fileRef = useRef();
    const fileWithoutStudentRef = useRef();
    const refForWithUser = React.useRef(null);
    const refForWithOutUser = React.useRef(null);

    const [NewAlerts, setNewAlerts] = useState("");
    const [fileName, setFileName] = useState({
        withStudent: '',
        withoutStudent: '',
        withStudentError: '',
        withoutStudentError: ''
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false,
        withStudentError: false,
        withoutStudentError: false
    });
    const [csvError, setCsvError] = useState("");

    async function ImportCSV(e, flag) {
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
        var temp = 0;
        e.preventDefault();
        const fileInput = flag == 1 ? fileRef.current : fileWithoutStudentRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: "First, import the CSV file.", [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
            fileInput.value = "";
            return;
        }
        temp++;
        const selectedfilename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 50 });
        if (!isFileValid) {
            setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: validationMsg, [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
            return;
        }
        setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: "", [flag == 1 ? 'withStudent' : 'withoutStudent']: selectedfilename });

        var formdata = new FormData();
        formdata.append("file", files);
        formdata.append("flag", flag);
        formdata.append("uuid", StateData?.csvUserID);
        formdata.append("schoolId", LogInSchoolID);
        setCsvError('');
        if (temp == 1) {
            const loaderRef = flag == 1 ? refForWithUser.current : refForWithOutUser.current;
            if (loaderRef) { loaderRef.continuousStart() }
            try {
                const response = await ApiCmnHeadersPostCall(`/inventory/upload`, formdata, false, true);
                const responseRs = JSON.parse(response);

                if (responseRs.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'The CSV import process is running in the background. Once the import is completed, you will receive an email notification.'} />);
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />);
                        navigate('/manage-device')
                    }, 4000);
                } else {
                    setCsvError(responseRs);
                    setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true, withStudentError: flag == 1 ? true : false, withoutStudentError: flag != 1 ? true : false });
                    fileInput.value = "";
                    setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: "", [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
                }
            } catch (error) {
                log.error('error', error);
                fileInput.value = "";
                setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: "", [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
            }
            finally {
                if (loaderRef) {
                    loaderRef.complete();
                    fileInput.value = "";
                    setFileName({ ...fileName, [flag == 1 ? 'withStudentError' : 'withoutStudentError']: "", [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
                }
            }
        }
    }
    function ShowFileName(flag) {
        const fileRefvar = flag == 1 ? fileRef.current : fileWithoutStudentRef.current;
        const key = flag == 1 ? 'withStudentError' : 'withoutStudentError';

        const files = fileRefvar.files[0];
        if (!files) return;
        const selectedfilename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 50 });
        if (!isFileValid) {
            setFileName({ ...fileName, [key]: validationMsg, [flag == 1 ? 'withStudent' : 'withoutStudent']: "" });
            return;
        }

        setFileName({ ...fileName, [key]: "", [flag == 1 ? 'withStudent' : 'withoutStudent']: selectedfilename });
    }

    return (
        <div>
            {NewAlerts}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Import Devices</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <label className='redText text-center pb-2'>Ensure the date format is in mm/dd/yyyy within the CSV file.</label>
            <div className="p-2">
                <p className="text-justify" style={{ fontSize: "13px" }}>
                    To ensure devices and data accuracy please download our CSV template file and ensure your columns match the template before you import your devices into the system.
                </p>

                <div className="row pt-1">
                    <div className="col-12">
                        <label className="pb-4 ps-2 text-justify" style={{ fontSize: "13px" }}>
                            <a onClick={() => downloadSampleCSV(withUserFileType, `${csvFilesPrefix ? `${csvFilesPrefix}_` : ''}Inventory_WithUsers.csv`)}
                                style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                                CLICK HERE
                            </a> {" "}
                            to download the template CSV file for devices with users data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                        </label>
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportCSV(e, 1)}>
                                <input type="file" ref={fileRef} name="upload_file" id="UploadDeviceFileId" accept='.csv' onChange={(e) => ShowFileName(1)} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadDeviceFileId"> Import Devices With Users
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.withStudent != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn && showErrorPopup.withStudentError &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        <div className=" ps-2 my-2" style={{ fontWeight: "600", color: 'green' }}>{fileName.withStudent}</div>
                        {fileName.withStudentError?.trim() != "" && <label className='redText'>{fileName.withStudentError}</label>}
                        <div className='position-relative'>  <LoadingBar style={{ borderRadius: "6px" }} color='var(--primary-color)' ref={refForWithUser} containerClassName='progressbarClass' /></div>
                    </div>
                    <div className="col-12 pt-3">
                        <label className="pb-4 ps-2 text-justify" style={{ fontSize: "13px" }}>
                            <a onClick={() => downloadSampleCSV(withoutUserFileType, `${csvFilesPrefix ? `${csvFilesPrefix}_` : ""}Inventory_WithoutUsers.csv`)}
                                style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                                CLICK HERE
                            </a>{" "}
                            to download the template CSV file for devices without users data (Use this import for all loaner devices). Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                        </label>
                        <div className='d-flex gap-3 align-items-center'>
                            <form onSubmit={(e) => ImportCSV(e, 2)}>
                                <input type="file" ref={fileWithoutStudentRef} name="upload_filewithoutstudent" id="UploadFileWithoutStudentId" accept='.csv' onChange={(e) => ShowFileName(2)} />
                                <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileWithoutStudentId"> Import Devices Without Users
                                    <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                </label>
                                {fileName.withoutStudent != '' ?
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                    :
                                    <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                }
                            </form>
                            {showErrorPopup.btn && showErrorPopup?.withoutStudentError &&
                                <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                    View Errors
                                </label>
                            }
                        </div>
                        <div className=" ps-2 my-2" style={{ fontWeight: "600", color: 'green' }}>{fileName.withoutStudent}</div>
                        {fileName.withoutStudentError?.trim() != "" && <label className='redText'>{fileName.withoutStudentError}</label>}
                        <div className='position-relative'> <LoadingBar style={{ borderRadius: "6px" }} color='var(--primary-color)' ref={refForWithOutUser} containerClassName='progressbarClass' /></div>
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />
        </div>
    )
}
